import { useEffect } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
import * as S from "./styled";
import { NumericFormat } from "react-number-format";
/**
 * hooks
 */
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from '../../../../hooks/useLoading';
/**
 * Components
 */
import LayoutModal from "../../../LayoutModal";
import Loading from "../../../Loading";
/**
 * Interface
*/
import { Inputs } from "Interfaces/IAccessory";

interface ICreate {
  isOpenModalUpdate: boolean;
  setModalClose: () => void;
  selectedUrlId: number | null;
  updateList: () => void;
}

export default function Update({
  isOpenModalUpdate,
  setModalClose,
  updateList,
  selectedUrlId,
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(`accessory/${selectedUrlId}`);
      const addressData = response.data;
      for (const key in addressData) {
        setValue(key as keyof Inputs, addressData[key]);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (selectedUrlId !== null) {
      fetchData();
    }
  }, [selectedUrlId]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    console.log('Update: ', data);
    try {

      const payload = {
        name: data.name,
        amount: data.amount,
        price: data.price,
      }
      const response = await apiRequest<Inputs>(`accessory/${selectedUrlId}`, 'PATCH', payload);
      const status = response.status;
      if (status === 200) {
        alert("Acessório atualizado com sucesso!");
        updateList();
        setModalClose();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o acessório.");
      console.log('Erro de atualização: ', error);
    } finally {
      stopLoading();
    }
  };

  if (isOpenModalUpdate) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Atualizar Acessório"
        subTitle="Atualize informações do acessório em sua base de dados."
        setModalClose={setModalClose}
        submiteModal={handleFormSubmit(onSubmit)}
        nameSubmit="Atualizar"

        nameIconMinimize={'Atualizar Acessório'}
      >

        {isLoading ? (
          <Loading />
        ) : (
          <S.Container>
            <S.FormInput>
              <S.Label>
                Nome do Acessório
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o nome"
                type="text"
                {...register("name", { required: true })}
              />
              {errors.name && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>Quantidade</S.Label>
                <S.Input
                  placeholder="Informe a quantidade"
                  type="number"
                  {...register("amount", { required: true })}
                />
                {errors.amount && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

              <S.FormInput>
                <S.Label>Preço</S.Label>
                <Controller
                  name="price"
                  control={control}
                  rules={{ required: 'Campo Obrigatório' }}
                  render={({ field: { onChange, value, ref } }) => (
                    <NumericFormat
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                      placeholder="R$ 0,00"
                      prefix="R$ "
                      value={value}
                      onValueChange={(values) => {
                        const purchaseValue = values.floatValue ?? 0;
                        onChange(purchaseValue); // Atualiza o valor de compra
                      }}
                      getInputRef={ref}
                    />
                  )}
                />
                {errors.price && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>
            </S.SeparateDiv>
          </S.Container>
        )}
      </LayoutModal>
    );
  }
  return null;
}
